import React from 'react';
import LegalPage from './LegalPage';

const PrivacyPolicyPage = () => (
  <LegalPage
    title="Privacy Policy"
    pageTitle="Privacy Policy"
    documentPath="/legal/privacy-policy.md"
  />
);

export default PrivacyPolicyPage;
